import { slideUp, slideDown } from './animations.js';

/**
 * Seteaza starea formului la fetch
 * @param {string} state 'loading' daca se incarca, '' daca nu. Default ''
 * @param {string} btnId Id buton submit. Default 'submit'
 * @param {string} loaderId Id buton loader. Default 'submitting'
 */
export const setLoadingState = (state = '', btnId = 'submit', loaderId = 'submitting') => {
	const btn = document.getElementById(btnId);
	const loader = document.getElementById(loaderId);

	const loading = state === 'loading';

	btn && (btn.hidden = loading);
	loader && (loader.hidden = !loading);
};

/**
 * Intoarce HTML alerta
 * @param {string} type danger | success | warning | info | neutral | transparent. Default 'danger'
 * @param {string} title Default 'Am întâmpinat o eroare'
 * @param {string} text Default 'Am întâmpinat o eroare la trimiterea formularului. Te rugăm să încerci din nou mai târziu.'
 * @returns {string}
 */
export const getAlertHtml = (type = 'danger', title = 'Am întâmpinat o eroare', text = 'Am întâmpinat o eroare la trimiterea formularului. Te rugăm să încerci din nou mai târziu.', className = 'mt-4') => {
	const icons = {
		danger: `<svg class="alert-icon flex-keep" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="m18.5 13.5-5 5m0-5 5 5M11 7.338A9.95 9.95 0 0 1 16 6c5.523 0 10 4.477 10 10s-4.477 10-10 10S6 21.523 6 16c0-1.821.487-3.53 1.338-5"></path></svg>`,
		success: `<svg class="alert-icon flex-keep" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m12.5 16.5 2 2 5-5"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M11 7.338A9.95 9.95 0 0 1 16 6c5.523 0 10 4.477 10 10s-4.477 10-10 10S6 21.523 6 16c0-1.821.487-3.53 1.338-5"></path></svg>`,
		warning: `<svg class="alert-icon flex-keep" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M16 12v4"></path><circle cx="16" cy="19" r=".5" fill="currentColor" stroke="currentColor"></circle><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M7 14.417c0-3.198 0-4.797.378-5.335.377-.537 1.88-1.052 4.887-2.081l.573-.196C14.405 6.268 15.188 6 16 6s1.595.268 3.162.805l.573.196c3.007 1.029 4.51 1.544 4.887 2.081C25 9.62 25 11.22 25 14.417v1.574c0 2.505-.837 4.437-2 5.913M7.193 18c.857 4.298 4.383 6.513 6.706 7.527.721.315 1.082.473 2.101.473 1.02 0 1.38-.158 2.101-.473.579-.252 1.231-.58 1.899-.994"></path></svg>`,
		info: `<svg class="alert-icon flex-keep" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M16 21v-6"></path><circle cx="1" cy="1" r=".5" fill="currentColor" stroke="currentColor" transform="matrix(1 0 0 -1 15 13)"></circle><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M11 7.338A9.95 9.95 0 0 1 16 6c5.523 0 10 4.477 10 10s-4.477 10-10 10S6 21.523 6 16c0-1.821.487-3.53 1.338-5"></path></svg>`,
		neutral: `<svg class="alert-icon flex-keep" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 6.674A7 7 0 0 1 23 13v.704c0 .845.25 1.671.719 2.374l1.148 1.723a2.77 2.77 0 0 1-1.576 4.21 27.7 27.7 0 0 1-14.582 0 2.77 2.77 0 0 1-1.576-4.21l1.148-1.723a4.3 4.3 0 0 0 .72-2.374V13c0-1.074.24-2.09.673-3M11.5 23c.655 1.748 2.422 3 4.5 3q.367 0 .72-.05M20.5 23a4.5 4.5 0 0 1-1.302 1.84"></path></svg>`,
		transparent: `<svg class="alert-icon flex-keep" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M13 6.674A7 7 0 0 1 23 13v.704c0 .845.25 1.671.719 2.374l1.148 1.723a2.77 2.77 0 0 1-1.576 4.21 27.7 27.7 0 0 1-14.582 0 2.77 2.77 0 0 1-1.576-4.21l1.148-1.723a4.3 4.3 0 0 0 .72-2.374V13c0-1.074.24-2.09.673-3M11.5 23c.655 1.748 2.422 3 4.5 3q.367 0 .72-.05M20.5 23a4.5 4.5 0 0 1-1.302 1.84"></path></svg>`,
	};

	return `
	<div id="response-message-inner" class="${className}">
		<div class="alert alert-${type}">
			${icons[type]}
			<div class="alert-inner">
				<p class="alert-title">${title}</p>
				<div class="alert-text t-deci">
					<p>${text}</p>
				</div>
			</div>
		</div>
	</div>
	`;
};

/**
 * Resetare form cu emitere de eveniment form:reset
 * @param {HTMLFormElement} form Form de resetat
 * @returns {undefined}
 */
export const resetForm = (form) => {
	if (!form || !(form instanceof HTMLFormElement)) {
		return;
	}

	form.reset();
	form.dispatchEvent(
		new Event('form:reset', {
			bubbles: true,
		}),
	);
};

/**
 * Gestioneaza campurile conditionate de valorile din alte campuri
 */
export class toggleFields {
	/**
	 * Constructor
	 * @param {HTMLElement} container Elementul care contine campurile
	 * @param {string} selector Selector campuri conditionate. Default '[data-toggle-visibility]'
	 */
	constructor(container, selector = '[data-toggle-visibility]') {
		if (!container) {
			throw new Error('container e undefined.');
		}

		const dataAttribute = selector.replace(/^\[data-|]$/g, '').replace(/-([a-z])/g, (_, c) => c.toUpperCase());

		this.fields = container.querySelectorAll(selector);
		this.container = container;

		this.toggleElements = [...this.fields]
			.map((field) => {
				try {
					return {
						element: field,
						config: JSON.parse(field.dataset[dataAttribute]),
					};
				} catch (err) {
					console.error(err.message, field);
					return null;
				}
			})
			.filter(Boolean);

		this.init();
		this.initSlideableElements();
		this.addListeners();
		this.checkAll();
	}

	/**
	 * Ascundere initiala elemente
	 */
	init() {
		this.toggleElements.forEach(({ element }) => {
			element.hidden = true;
		});
	}

	/**
	 * Adauga clasa 'will-slide-down' la elementele care au comportament de slide
	 */
	initSlideableElements() {
		this.toggleElements.forEach(({ element, config }) => {
			const { slide } = config;
			element.classList.toggle('will-slide-down', !!slide);
		});
	}

	/**
	 * 'change' event delegation, plus initializare la event 'form:reset'
	 */
	addListeners() {
		document.addEventListener('change', () => {
			this.checkAll();
		});

		this.container.addEventListener('form:reset', (e) => {
			if (e.target === this.container) {
				this.init();
			}
		});
	}

	/**
	 * Gestioneaza ascunderea/afisarea elementelor (cu sau fara efect de slide)
	 */
	checkAll() {
		this.toggleElements.forEach(({ element, config }) => {
			const { slide, conditions } = config;
			const shouldSlide = !!slide;

			let shouldShow = false;

			conditions.forEach((group) => {
				let groupMatches = true;
				Object.keys(group).forEach((fieldName) => {
					const expectedValue = group[fieldName];
					const inputs = document.querySelectorAll(`[name="${fieldName}"]`);

					if (inputs.length === 0) {
						groupMatches = false;
						return;
					}

					let currentValue = '';
					const type = inputs[0].type;

					if (type === 'radio' || type === 'checkbox') {
						inputs.forEach((input) => {
							if (input.checked) {
								currentValue = input.value;
							}
						});
					} else {
						currentValue = inputs[0].value;
					}

					let valueMatches = false;
					const possibleValues = String(expectedValue)
						.split('||')
						.map((v) => v.trim());

					possibleValues.forEach((value) => {
						if (value === String(currentValue)) {
							valueMatches = true;
						}
					});

					if (!valueMatches) {
						groupMatches = false;
					}
				});

				if (groupMatches) {
					shouldShow = true;
				}
			});

			if (shouldShow && element.hidden) {
				if (shouldSlide) {
					slideDown(element);
				} else {
					element.hidden = false;
				}
			} else if (!shouldShow && !element.hidden) {
				if (shouldSlide) {
					slideUp(element);
				} else {
					element.hidden = true;
				}
			}
		});
	}
}
